import React, { } from "react";
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import LoaderUI from "../components/common/loader/index";
import Footer from "../components/Footer"
const PublicLayout = ({ children }) => {
    const history = useHistory();
    let loggedIn = useSelector(state => state.user.loggedIn);
    let registered = useSelector(state => state.user.registered);
    let isLoading = useSelector(state => state.general.loading);
    if (registered) {
        history.push('/dashboard')
        return null;
    }
    if (loggedIn && !children.props.location.pathname.includes("/terms-and-condition")) {
        history.push('/dashboard');
        return null;
    }

    return (
        <>
            <div className="signup-wrapper d-flex flex-fill overflow-auto">
                {
                    (children.props.location.pathname.includes("/terms-and-condition") || children.props.location.pathname.includes("/dashboardliveStats") || children.props.location.pathname.includes("/DashboardliveStats")) ? null : <div className={`col-blc left-col d-flex`}>
                        <div className="inner d-flex align-items-end justify-content-center flex-fill position-relative">
                            <img className="img-fluid" src={require('../assets/img/login/character.svg')} alt="Login-Character" />
                        </div>
                    </div>
                }


                <div className="col-blc right-col d-flex overflow-auto">
                    {/* {isLoading && <LoaderUI
                        loader={isLoading}
                        overlay={true}
                        overlayRadius='rounded-0'
                        size=""
                    />} */}
                    {children}
                </div>
            </div>
            {/* <Footer /> */}
        </>
    )
};

PublicLayout.propTypes = {
    /**
     * Whether to display the navbar, or not.
     */
    noNavbar: PropTypes.bool,
    /**
     * Whether to display the footer, or not.
     */
    noFooter: PropTypes.bool
};

PublicLayout.defaultProps = {
    noNavbar: false,
    noFooter: false
};

export default PublicLayout;
